import objectFitImages from 'object-fit-images';
import {
  observeFunc,
  waitFunc,
  fadeInFunc,
} from "./common/_common";
import {
  headerNavFunc,
} from"./common/_header"
import{
  buttonActionFunc,
  langActionFunc,
} from"./common/_buttonAction"
import{
  pageLinkAnimationFunc,
} from"./common/_pageLinkAnimation"
import{
  animeLinkFunc,
} from"./common/_hoverFunc"

import{
  idxFunc,
} from"./pages/_index"
import{
  companyFunc,
} from"./pages/_company"
import{
  newsFunc,
} from"./pages/_news"
import{
  mediaFunc,
} from"./pages/_media"
import{
  serviceFunc,
} from"./pages/_service"
import{
  careersFunc,
} from"./pages/_careers"
import{
  aboutFunc,
} from"./pages/_about"
import{
  contactFunc,
} from"./pages/_contact"
//* ---------------------------------------
//通常実行
//-------------------------------------- */
let setTimer = false;
//* ----------------------------------------
//window実行
//--------------------------------------- */
////// ロード時
$(document).ready(function(){
  var urlHash = location.hash;
    if (urlHash) {
      $('body,html').stop().scrollTop(0);
      setTimeout(function(){
        var headerHight = $('#header').outerHeight();
        var subNavHeight = $('#subNav').outerHeight();
        var target = $(urlHash);
        if (window.matchMedia("(max-width: 768px)").matches) {
          var position = target.offset().top - headerHight - subNavHeight - 30;
        } else {
          var position = target.offset().top - headerHight - subNavHeight;
        };
        $('body,html').stop().animate({scrollTop:position}, 1000, 'easeInOutQuart');
    }, 100);
  }
});

$(window).on('load', function () {
  headerNavFunc();
  buttonActionFunc();
  pageLinkAnimationFunc();
  animeLinkFunc();
  fadeInFunc();
  langActionFunc();

  idxFunc();
  companyFunc();
  newsFunc();
  mediaFunc();
  serviceFunc();
  careersFunc();
  aboutFunc();
  contactFunc();
});

// リサイズ時
/*リサイズ後,200msで発火する設定*/
$(window).on('resize', function () {
  if (setTimer !== false) {
    clearTimeout(setTimer);
  }
  setTimer = setTimeout(() => {
    //処理
  }, 200);
});

// スクロール時
$(window).on('scroll', function () {
  if (setTimer !== false) {
    clearTimeout(setTimer);
  }
  setTimer = setTimeout(() => {
    //処理
  }, 200);
});
///* -----------------------------------------------
//ユーザーエージェント判別実行(uaFlag：1→スマホ&タブレット・2→IE・3→その他PC)
//----------------------------------------------- */
var uaFlag = 0;
if ((
    navigator.userAgent.indexOf('iPhone') > 0) ||
  (navigator.userAgent.indexOf('iPod') > 0) ||
  (navigator.userAgent.indexOf('iPad') > 0) ||
  (navigator.userAgent.indexOf('Android') > 0) ||
  (navigator.userAgent.indexOf('BlackBerry') > 0) ||
  (navigator.userAgent.indexOf('PlayBook') > 0) ||
  (navigator.userAgent.indexOf('Kindle') > 0) ||
  (navigator.userAgent.indexOf('Silk') > 0) ||
  (navigator.userAgent.indexOf('Windows Phone') > 0) ||
  (navigator.userAgent.indexOf('Nokia') > 0)
) {
  // スマホ・タブレット時の処理
  uaFlag = 1;
} else {
  // PC時の処理
  uaFlag = 3;
}
/* -----------------------------------------------
IEだけの時
----------------------------------------------- */
var userAgent = window.navigator.userAgent.toLowerCase();
if (userAgent.match(/(msie|MSIE)/) || userAgent.match(/(T|t)rident/)) {

}